const FaqData = [
  {
    page: "physiotherapy",
    id: 0,
    title: "What Are the Benefits of Physiotherapy at Home?",
    content: "Physiotherapy at home provides personalized treatment in a comfortable environment. It can help improve mobility, flexibility, strength, and physical function according to the patient's needs."
  },
  {
    page: "physiotherapy",
    id: 1,
    title: "What Conditions Can Home Physiotherapy Help With?",
    content: "Home physiotherapy services may help patients recovering from surgery, injuries, strokes, joint pain, muscle stiffness, and mobility difficulties, depending on their condition."
  },
  {
    page: "physiotherapy",
    id: 2,
    title: "Who Can Benefit from Physiotherapy at Home?",
    content: "Physiotherapy at home can benefit elderly individuals, post-surgery patients, people with mobility limitations, and patients who find it difficult to travel to a clinic."
  },
  {
    page: "physiotherapy",
    id: 3,
    title: "How Much Does Physiotherapy at Home Cost?",
    content: "The cost of physiotherapy services at home depends on the treatment required, session duration, location, and number of sessions. Contact CaresAtHome for current pricing and availability."
  },
  {
    page: "physiotherapy",
    id: 4,
    title: "How Can I Book a Home Physiotherapist?",
    content: "You can visit the CaresAtHome website, explore the available home physiotherapy services, and follow the booking process to arrange an appointment based on your requirements."  
  },
  {
    page: "physiotherapy",
    id: 5,
    title: "How Often Should I Schedule Physiotherapy Sessions at Home?",
    content: "The frequency of home physiotherapy sessions depends on the patient's condition, recovery goals, and treatment plan. A qualified physiotherapist can recommend a suitable schedule after assessing the patient's needs."  
  },
  {
    page: "physiotherapy",
    id: 6,
    title: "Is Home Physiotherapy Suitable for Elderly Patients?",
    content: "Yes, home physiotherapy can help elderly patients improve mobility, balance, flexibility, and muscle strength. The treatment plan should be tailored to their physical condition and recommended by a qualified physiotherapist."  
  },



  {
    page: "bedsideattendant",
    id: 7,
    title: "What Are Bedside Attendant Services at Home?",
    content: ( <> <a href="/home-bedsideattendant">Bedside attendant services at home</a>  provide non-medical assistance to patients who need help with daily activities, personal hygiene, mobility, and comfort in their home environment.</> )
  },
  {
    page: "bedsideattendant",
    id: 8,
    title: "Who Needs a Bedside Attendant at Home?",
    content: ( <>A <a href="/home-bedsideattendant">bedside attendant at home</a>   can support elderly individuals, bedridden patients, post-surgery patients, and people who need assistance with everyday activities.</> )
  },
  {
    page: "bedsideattendant",
    id: 9,
    title: "What Services Does a Bedside Attendant Provide?",
    content: ( <> <a href="/home-bedsideattendant">Bedside attendant services</a>  may include bathing assistance, dressing, feeding support, mobility assistance, repositioning, and help with other daily personal care needs.</> )
  },
  {
    page: "bedsideattendant",
    id: 10,
    title: " Can I Hire a Bedside Attendant for Elderly Patient Care?",
    content: ( <>Yes,  <a href="/home-bedsideattendant">elderly care attendants at home</a> can help senior citizens with daily routines, personal care, mobility, and companionship according to their individual needs.</> )
  },
  {
    page: "bedsideattendant",
    id: 11,
    title: "How Can I Book Bedside Attendant Services at Home?",
    content: "You can visit the CaresAtHome website, explore the available patient attendant services, and contact the team to discuss your requirements, service duration, pricing, and availability."  
  },
  {
    page: "bedsideattendant",
    id: 12,
    title: "Are Bedside Attendant Services Available for 24 Hours?",
    content: "Yes, bedside attendant services may be available for 24-hour support, depending on the patient's care requirements and service availability. Families can contact CaresAtHome to discuss suitable care options."  
  },
  {
    page: "bedsideattendant",
    id: 13,
    title: "What Is the Difference Between a Bedside Attendant and a Home Nurse?",
    content: "A bedside attendant provides non-medical assistance with daily activities, personal hygiene, mobility, and comfort. A home nurse provides professional nursing care, such as medication administration, wound dressing, and other clinical procedures within their qualifications and scope of practice."  
  },
  





  {
    page: "nursingcare",
    id: 14,
    title: "What Are the Benefits of Home Nursing Care?",
    content: ( <> <a href="/home-nursingcare">Home nursing care</a> allows patients to receive personalized healthcare support in a familiar environment. It can help with daily care needs, recovery support, and assistance for elderly or bedridden patients.</> )
  },
  {
    page: "nursingcare",
    id: 15,
    title: "What Types of Nursing Services Are Available at Home?",
    content: ( <> <a href="/home-nursingcare">Nursing services at home</a> may include blood sugar monitoring, blood pressure monitoring, wound care, diabetic foot care, bedridden patient care, and other nursing procedures based on individual needs.</> )
  },
  {
    page: "nursingcare",
    id: 16,
    title: "Can I Book a Nurse for Elderly Patient Care at Home?",
    content: ( <> Yes, <a href="/home-nursingcare">elderly nursing care at home</a> can help senior citizens with their healthcare needs, mobility assistance, personal care, and other support depending on their condition.</> )
  },
  {
    page: "nursingcare",
    id: 17,
    title: "How Much Do Home Nursing Care Services Cost?",
    content: ( <> The cost of <a href="/home-nursingcare">home nursing care services </a> depends on the type of service, visit duration, and the patient's requirements. You can check the listed prices on CaresAtHome or contact the team for current pricing.</> )
  },
  {
    page: "nursingcare",
    id: 18,
    title: "How Can I Book Nursing Care Services at Home?",
    content: ( <> You can visit the CaresAtHome <a href="/home-nursingcare">Home Nursing Care </a> page, select the required nursing service, review the available options, and follow the booking process to arrange care for your loved one.</> )
  },
  {
    page: "nursingcare",
    id: 19,
    title: " Is 24-Hour Nursing Care Available at Home?",
    content: "Yes, 24-hour nursing care may be available depending on the patient's medical condition and care requirements. Contact CaresAtHome to check the available nursing options and suitable care plans."  
  },
  {
    page: "nursingcare",
    id: 20,
    title: "Can Home Nursing Care Help Patients Recover After Surgery?",
    content: "Yes, home nursing care can support post-operative recovery through prescribed wound care, vital sign monitoring, medication assistance, and other nursing services as recommended by the treating doctor."  
  },




  {
    page: "productonrent",
    id: 21,
    title: "What Medical Products Are Available on Rent?",
    content: ( <> <a href="/product-on-rent">Medical products on rent </a> may include hospital beds, wheelchairs, oxygen concentrators, suction machines, patient monitors, and other medical equipment, depending on availability.</> )
  },
  {
    page: "productonrent",
    id: 22,
    title: "What Are the Benefits of Renting Medical Equipment?",
    content: ( <> <a href="/product-on-rent">Medical equipment rental services </a> offer a convenient option for patients who need healthcare equipment temporarily for recovery, rehabilitation, or home care without purchasing it outright.</> )
  },
  {
    page: "productonrent",
    id: 23,
    title: " Can I Rent a Hospital Bed for Home Use?",
    content: ( <>Yes, you can explore <a href="/product-on-rent">hospital beds on rent </a> for patient comfort, easier positioning, and support with daily caregiving at home, subject to availability.</> )
  },
  {
    page: "productonrent",
    id: 24,
    title: "Is Medical Equipment Available for Short-Term and Long-Term Rental?",
    content: ( <>Many  <a href="/product-on-rent"> medical products rental services </a>offer flexible rental periods based on the equipment, patient requirements, and rental terms.</> )
  },
  {
    page: "productonrent",
    id: 25,
    title: "How Can I Book Medical Products on Rent?",
    content: ( <>You can visit the CaresAtHome website, browse available   <a href="/product-on-rent">  medical equipment on rent </a>select the required product, and contact the team to confirm pricing, availability, delivery, and rental duration.</> )
  },
  {
    page: "productonrent",
    id: 26,
    title: " Is Medical Equipment Available for Home Patient Care?",
    content: "Yes, medical equipment such as hospital beds, wheelchairs, and oxygen concentrators may be available for home patient care, depending on the patient's requirements and product availability."  
  },
  {
    page: "productonrent",
    id: 27,
    title: " What Should I Check Before Renting Medical Equipment?",
    content: "Before renting medical equipment, check its condition, suitability for the patient's needs, rental charges, delivery arrangements, maintenance support, and rental duration. Consult a healthcare professional to determine which equipment is appropriate for the patient."  
  },




  {
    page: "icuhospital",
    id: 28,
    title: "What Is an ICU Setup at a Hospital? ",
    content: ( <>An <a href="/icu-installation-at-hospital">  ICU setup at a hospital </a>is a specialized medical care unit designed for patients who need continuous monitoring, advanced medical equipment, and intensive treatment under the supervision of healthcare professionals.</> )
  },
  {
    page: "icuhospital",
    id: 29,
    title: " What Equipment Is Available in a Hospital ICU? ",
    content: ( <>A <a href="/icu-installation-at-hospital">  hospital ICU setup </a>may include ICU beds, ventilators, multiparameter patient monitors, infusion pumps, suction machines, oxygen delivery systems, and other critical care equipment based on the patient's condition.</> )
  },
  {
    page: "icuhospital",
    id: 30,
    title: " Which Patients Need ICU Admission?",
    content: "Patients with serious illnesses, major injuries, complications after surgery, severe breathing difficulties, or unstable vital signs may require intensive care unit (ICU) services as recommended by their treating medical team."  
  },
  {
    page: "icuhospital",
    id: 31,
    title: " What Medical Support Is Provided in a Hospital ICU? ",
    content: ( <> <a href="/icu-installation-at-hospital"> ICU care services </a> may include continuous vital sign monitoring, respiratory support, medication administration, fluid management, and specialised nursing care provided by trained healthcare professionals according to the patient's treatment plan.</> )
  },
  {
    page: "icuhospital",
    id: 32,
    title: "How Can I Arrange ICU Admission for a Patient? ",
    content: "To arrange hospital ICU care, contact the hospital's emergency department or treating doctor. The medical team will assess the patient's condition, determine the need for intensive care, and guide you regarding ICU bed availability and admission procedures."  
  },
  {
    page: "icuhospital",
    id: 33,
    title: "What Factors Should Be Considered When Setting Up a Hospital ICU? ",
    content: "A hospital ICU setup should consider the number of ICU beds required, essential medical equipment, oxygen supply, patient monitoring systems, infection control measures, and the availability of trained healthcare professionals."  
  },
  {
    page: "icuhospital",
    id: 34,
    title: "Can ICU Equipment Be Installed in an Existing Hospital? ",
    content: "Yes, ICU equipment can be installed in an existing hospital after assessing the available space, electrical infrastructure, oxygen supply, and other medical requirements. Professional guidance can help ensure the setup meets applicable healthcare standards."  
  },





   {
    page: "drconsult",
    id: 35,
    title: "What Are Doctor Consultation Services?",
    content: ( <> <a href="/doctor-consultation-services"> Doctor consultation services  </a> allow patients to discuss their health concerns with qualified medical professionals, receive medical advice, and understand suitable treatment options based on their symptoms and medical history.</> )
  },
     {
    page: "drconsult",
    id: 36,
    title: "Can I Book a Doctor Consultation at Home?",
    content: ( <>Yes, you can inquire about <a href="/doctor-consultation-services"> doctor's location consultations at home </a> through CaresAtHome. Home visits may be available depending on your location, doctor's availability, and medical requirements.</> )
  },
     {
    page: "drconsult",
    id: 37,
    title: "Which Medical Conditions Can Be Discussed During a Doctor Consultation?",
    content: ( <>A <a href="/doctor-consultation-services">  doctor consultation service </a> can help address common health concerns, ongoing medical conditions, medication-related questions, and general health assessments. Emergency symptoms require immediate medical attention.</> )
  },
     {
    page: "drconsult",
    id: 38,
    title: " How Can I Book an Appointment with a Doctor?",
    content: ( <>You can contact CaresAtHome to inquire about available <a href="/doctor-consultation-services"> doctor appointments,  </a> consultation options, timings, and applicable fees. Share your requirements to help the team guide you through the booking process.</> )
  },
     {
    page: "drconsult",
    id: 39,
    title: " What Are the Benefits of Professional Doctor Consultation Services?",
    content: ( <>Professional  <a href="/doctor-consultation-services">  medical consultation services </a>help patients understand their health concerns, discuss treatment options, receive appropriate medical guidance, and determine whether further examination or specialist care is needed. </> )
  },
     {
    page: "drconsult",
    id: 40,
    title: "Can I Consult a Doctor for Elderly Family Members at Home?",
    content: "Yes, you can inquire about doctor consultations at home for elderly family members through CaresAtHome. Availability depends on the patient's location, medical needs, and the doctor's schedule."  
  },
  {
    page: "drconsult",
    id: 41,
    title: " What Information Should I Provide Before a Doctor Consultation?  ",
    content: "Before a doctor consultation, share the patient's symptoms, medical history, current medications, existing health conditions, and any relevant medical reports. This information can help the doctor assess the patient's concerns and provide appropriate medical guidance."  
  },




  {
    page: "icuhome",
    id: 42,
    title: " What Is an ICU Setup at Home?",
    content: ( <>An  <a href="/icu-installation-at-home">  ICU setup at home</a> provides hospital-like medical equipment and care arrangements at home for patients who require intensive monitoring and medical support, as prescribed by their treating doctor.</> )
  },
  {
    page: "icuhome",
    id: 43,
    title: "What Equipment Is Required for an ICU Setup at Home?",
    content: ( <>A  <a href="/icu-installation-at-home"> home ICU setup </a> may include a hospital bed, oxygen equipment, a patient monitor, a suction machine, and a ventilator when medically required. Equipment depends on the patient's condition and doctor's recommendations.</> )
  },
  {
    page: "icuhome",
    id: 44,
    title: "Who Needs ICU Care at Home?",
    content: ( <>  <a href="/icu-installation-at-home"> ICU care at home </a>may be considered for selected patients who need ongoing medical monitoring, respiratory support, or specialised nursing care and whose condition is suitable for home care as determined by their treating doctor. </> )
  },
  {
    page: "icuhome",
    id: 45,
    title: "Is a Nurse Available for ICU Care at Home?",
    content: ( <>  <a href="/icu-installation-at-home">ICU nursing care at home  </a>  may include trained nursing professionals to monitor the patient's condition, provide prescribed care, and assist with medical equipment according to the care plan and service availability.</> )
  },
  {
    page: "icuhome",
    id: 46,
    title: "How Can I Arrange an ICU Setup at Home?",
    content: ( <> You can contact CaresAtHome to discuss the patient's requirements, available <a href="/icu-installation-at-home"> home ICU equipment, </a>  nursing support, and setup arrangements. A treating doctor's assessment is essential before arranging intensive care at home.</> )
  },
  {
    page: "icuhome",
    id: 47,
    title: " What Factors Should Be Considered Before Setting Up an ICU at Home?",
    content: "Before arranging a home ICU setup, consider the patient's medical condition, required equipment, oxygen supply, availability of trained nursing staff, power backup, and emergency support. The treating doctor should assess whether home ICU care is appropriate."  
  },
  {
    page: "icuhome",
    id: 48,
    title: "Can ICU Equipment Be Customized According to the Patient's Needs?",
    content: "Yes, a home ICU setup can be arranged according to the patient's medical requirements and the treating doctor's recommendations. The equipment needed may vary depending on the patient's condition, monitoring requirements, and prescribed treatment plan."  
  },




  {
    page: "homemaine",
    id: 49,
    title: "What are home healthcare services?",
    content: ( <>Home healthcare services include <a href="/home-nursingcare"> nursing care,</a> physiotherapy, doctor consultations, diagnostic tests, and patient care provided at the patient’s home. </> )
  },
  {
    page: "homemaine",
    id: 50,
    title: "Do you provide 24/7 nursing care at home in Jaipur?",
    content:"Yes, we provide round-the-clock nursing and caregiver services depending on the patient’s condition and requirements."
  },
  {
    page: "homemaine",
    id: 51,
    title: "Can I book physiotherapy sessions at home?",
    content: "Yes, our licensed physiotherapists provide personalised treatment sessions at home across Jaipur."
  },
  {
    page: "homemaine",
    id: 52,
    title: "Do you offer ICU setup at home?",
    content: "Yes, we provide complete ICU setup services with hospital-grade equipment and trained critical care staff."
  },
  {
    page: "homemaine",
    id: 53,
    title: "How can I book a home healthcare service?",
    content: "You can call our helpline or fill out the online appointment form to schedule a home visit."
  },
  {
    page: "homemaine",
    id: 54,
    title: "What Home Healthcare Services Are Available in Jaipur?",
    content: "CaresAtHome offers nursing care, bedside attendants, doctor consultations, physiotherapy, home ICU setup, and medical equipment rentals in Jaipur."
  },
  {
    page: "homemaine",
    id: 55,
    title: "How Do I Choose the Right Home Healthcare Service?",
    content:"Choose a service based on the patient's medical condition and care needs. Consult a healthcare professional for guidance on suitable nursing, physiotherapy, or patient care services."
  },

  
];

export default FaqData;